import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { staticImplements } from "@/utilities/static-implements";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { DosageValuesRange } from "./dosage-values-range";
import { StdAprioriValue } from "../../drug-common/std-apriori-value";

@staticImplements<ResponseModelInterfaceStatic>()
export class DosageAvailableValues
{
    public constructor(
        public unit: string,
        public defaultAprioriValue: StdAprioriValue,

        protected sourceRanges: DosageValuesRange[],
        protected sourceFixedValues: number[],
    )
    {
    }

    public static makeFromXml(elem: XmlElementWrapper): DosageAvailableValues
    {
        const sourceFixedValues = (
            elem
                .firstChildByTagOrNull("fixedValues")
                ?.mapForEachChildTag("value", (subElem) => subElem.valueAsNumber())
        ) ?? new Array<number>();

        return new this(
            elem.firstChildByTag("unit").value(),
            StdAprioriValue.makeFromXml(elem.firstChildByTag("default")),
            elem.mapForEachChildTag("rangeValues", (subElem: XmlElementWrapper) => DosageValuesRange.makeFromXml(subElem)),
            sourceFixedValues,
        );
    }

    public get defaultValue() : number
    {
        return this.defaultAprioriValue.value;
    }

    public get values() : number[]
    {
        // Copy all fixed values
        let values = [...this.sourceFixedValues];

        // Add all ranges to the list
        for (const range of this.sourceRanges) {
            values.push(...range.values);
        }

        // Sort all values by ascending order
        values = values.sort((a, b) => {
            return a - b;
        });

        // Remove duplicate values, knowing that all of them are sorted
        const uniqueValues = [];
        let lastValue = null as number|null;

        for (let i = 0; i < values.length; i++) {
            if (values[i] === lastValue) {
                continue;
            }

            uniqueValues.push(values[i]);
            lastValue = values[i];
        }

        return uniqueValues;
    }
}
